const selectZoneDevices = state => state.data.zoneDevices

const ZoneDeviceDataStoreSelectors = {
  zoneDevices: selectZoneDevices
}

export default ZoneDeviceDataStoreSelectors
